/*Состояния*/
const state = () => ({
  orderSuccess: "",

  modalActive: false,

  message: "",
});
export { state };
